import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { getIcons } from "../../Constant/Constant";
import leadSourceService from "../../Services/LeadSourceService";
import LeadSourceDropdown from "../../Form/LeadTable/LeadSourceDropdown";
import useOutsideClick from "../../../hooks/useOutsideClick";
import CustomSelect from "../../common/CustomSelect";
import InterestedTagService from "../../Services/InterestedTagService";
import LocationService from "../../Services/LocationService";
import PropertiesService from "../../Services/PropertiesService";
import { statusIcons } from "../../../Enum/LeadEnumConstants";
import {
  leadCharacterEmoji,
  interestLevel,
} from "../../../Enum/LeadEnumConstants";
import { GLPagePropertyTypeList } from "../../../Enum/GLPageEnumConstants";
import { showInfoToast } from "../../Constant/Notification";
import { getLeadSourcesFromCache } from "../../../hooks/useLeadSourceCache";

const icons = getIcons();

const LeadDetail = ({ lead, isEdit, leadInfo, setLeadInfo }) => {
  const location = useLocation();
  const leadId = location.pathname.split("/").pop();

  const dropdownRef = useRef();
  const dropdownRef2 = useRef();
  const dropdownRef3 = useRef();
  const [leadSourceSearch, setLeadSourceSearch] = useState("");
  const [selectedLeadSource, setSelectedLeadSource] = useState("");
  const [open, setOpen] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [openInterest, setOpenInterest] = useState(false);
  const [interestedTags, setInterestedTags] = useState([]);
  const [optionLocation, setOptionLocation] = useState([]);
  const [leadSource, setLeadSource] = useState(leadInfo?.value);
  const [propertyList, setPropertyList] = useState([]);
  useEffect(() => {
    const sources = getLeadSourcesFromCache();
    console.log(sources);

    const data = sources.map((list) => ({
      label: list.name,
      value: list.id,
    }));
    setLeadSource(data);
  }, []);

  const handleChange = (name, value) => {
    setLeadInfo({
      ...leadInfo,
      [name]: value,
    });
  };

  // const fetchLeadSourceList = async () => {
  //   try {
  //     const response = await leadSourceService.getLeadSource(leadSourceSearch);
  //     setLeadSource(response.data);
  //   } catch (error) {
  //     console.error("Error fetching lead sources:", error);
  //     showInfoToast("Failed to fetch lead sources.");
  //     setLeadSource([]);
  //   }
  // };

  const fetchPropertyList = async (inputValue = "") => {
    try {
      const response = await PropertiesService.getPropertyList(
        inputValue,
        leadInfo.interestedCategory?.value
      );
      const propertyData =
        response.data?.map((list) => ({
          value: list.id,
          label: list.name,
        })) || [];
      setPropertyList(propertyData);
    } catch (error) {
      console.error("Failed to fetch property list:", error);
      showInfoToast("Failed to fetch property list.");
      setPropertyList([]);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const [responseTags, responseLocation] = await Promise.all([
          InterestedTagService.fetchInterestedTag(),
          LocationService.fetchLocation(),
        ]);
        setInterestedTags(
          responseTags.data.map((item) => ({
            value: item.id,
            label: item.name,
          })) || []
        );
        const dataLocation = responseLocation.data;
        setOptionLocation(
          Object.entries(dataLocation).map(([name, id]) => ({
            value: id,
            label: name,
          })) || []
        );
      } catch (error) {
        console.error("Error fetching interested tags or locations:", error);
      }
    })();
  }, []);

  useEffect(() => {
    fetchPropertyList();
  }, [leadInfo.interestedCategory]);

  useOutsideClick(dropdownRef, () => {
    setOpen(false);
  });

  useOutsideClick(dropdownRef2, () => {
    setOpenStatus(false);
  });

  useOutsideClick(dropdownRef3, () => {
    setOpenInterest(false);
  });

  const handlePropertyType = (selectedPropertyType) => {
    handleChange("interestedCategory", selectedPropertyType);
  };

  const handlePropertyChange = (selected) => {
    handleChange("interestedProperty", selected);
  };

  const handleInputChange = (newValue) => {
    fetchPropertyList(newValue);
  };

  return (
    <div className="w-full bg-white rounded overflow-y-auto custom-scrollbar">
      <form className="w-full">
        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="name"
          >
            Name
          </label>
          <input
            className={`${
              !isEdit ? "cursor-pointer" : "cursor-default"
            } border rounded w-3/4 py-2 px-3 text-gray-700 input-focus`}
            type="text"
            name="name"
            disabled={isEdit}
            maxLength={60}
            required
            value={leadInfo.name || ""}
            onChange={(e) => handleChange(e.target.name, e.target.value)}
          />
        </div>

        <div class="mb-8 flex items-center ">
          <label
            class="w-2/4 text-[#404040] text-[18px] font-medium"
            for="phoneNumber"
          >
            Phone Number
          </label>
          <div class="w-3/4 gap-2 flex items-center">
            <input
              className={`${
                !isEdit ? "cursor-pointer" : "cursor-default"
              } border rounded w-20 py-2 px-3 text-gray-700 input-focus`}
              name="countryCode"
              type="text"
              disabled={isEdit}
              
              required
              value={`+${leadInfo.countryCode || ""}`}
              onChange={(e) =>
                handleChange(e.target.name, e.target.value.replace("+", ""))
              }
            />
            <input
              className={`${
                !isEdit ? "cursor-pointer" : "cursor-default"
              } w-full border rounded py-2 px-3 text-gray-700 input-focus`}
              name="phoneNumber"
              maxLength={10}
              type="text"
              required
              disabled={isEdit}
              value={leadInfo.phoneNumber || ""}
              onChange={(e) => {
                const onlyNumbers = e.target.value.replace(/\D/g, ""); // Remove non-digits
                handleChange(e.target.name, onlyNumbers);
              }}     />
          </div>
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="emailId"
          >
            Email ID
          </label>
          <input
            className={`${
              !isEdit ? "cursor-pointer" : "cursor-default"
            } border rounded w-3/4 py-2 px-3 text-gray-700 input-focus`}
            name="emailId"
            type="text"
            required
            disabled={isEdit}
            value={leadInfo.emailId || ""}
            onChange={(e) => handleChange(e.target.name, e.target.value)}
          />
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="createdTime"
          >
            Created Date
          </label>
          <input
            className={`${
              !isEdit ? "cursor-pointer" : "cursor-default"
            } border rounded w-3/4 py-2 px-3 text-gray-700 input-focus`}
            id="createdTime"
            type="text"
            required
            disabled
            value={leadInfo.createdTime || ""}
          />
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="leadSource"
          >
            Lead Source
          </label>

          <div className="w-3/4">
            <CustomSelect
              value={leadInfo.leadSource}
              onChange={(selectedOptions) =>
                handleChange("leadSource", selectedOptions)
              }
              options={leadSource}
              placeholder="Lead Source"
              disabled={isEdit}
            />
          </div>
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="assignedTeam"
          >
            Assigned Team
          </label>
          <input
            className="cursor-default border rounded w-3/4 py-2 px-3 text-gray-700 input-focus"
            type="text"
            required
            disabled
            value={leadInfo.assignedTeam || ""}
          />
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="uploadedBy"
          >
            Lead Uploaded By
          </label>
          <input
            className="cursor-default border rounded w-3/4 py-2 px-3 text-gray-700 input-focus"
            type="text"
            required
            disabled
            value={leadInfo.uploadedBy || ""}
          />
        </div>



        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="assignedTeam"
          >
            Source Type
          </label>
          <div className="flex items-center gap-4">
            <div className="flex gap-8 items-center">
              <div className="flex items-center gap-3">
                <input
                  type="radio"
                  id="manual"
                  name="isManagement"
                  value="Manual"
                  className="w-5 h-5 "
                  checked={leadInfo.isManagement === true}
                  onChange={(e) => {
                    setLeadInfo((prev) => ({ ...prev, isManagement: true }));
                  }}
                />
                <label>Managment Lead</label>
              </div>

              <div className="flex items-center gap-3">
                <input
                  type="radio"
                  id="manual"
                  name="isManagement"
                  value="Manual"
                  className="w-5 h-5 "
                  checked={leadInfo.isManagement === false}
                  onChange={(e) => {
                    setLeadInfo((prev) => ({ ...prev, isManagement: false }));
                  }}
                />
                <label>Own Lead</label>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="assignedUser"
          >
            Lead Owner
          </label>
          <input
            className="shadow appearance-none font-semibold cursor-default border rounded w-3/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            required
            disabled
            value={leadInfo.assignedUser || ""}
          />
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="leadQuality"
          >
            Lead Quality
          </label>
          <div className="relative w-3/4" ref={dropdownRef}>
            <div
              onClick={() => !isEdit && setOpen(!open)}
              className={`flex items-center justify-between w-full px-3 py-2 border rounded ${
                isEdit ? "cursor-default" : "cursor-pointer"
              }`}
            >
              <div className="flex items-center gap-2">
                {leadInfo.leadQuality?.label ? (
                  <>
                    <img
                      src={
                        interestLevel.find(
                          (i) => i.label === leadInfo.leadQuality?.label
                        )?.image || ""
                      }
                      alt={leadInfo.leadQuality?.label || "Select Quality"}
                      className="h-5 w-5"
                    />
                    <span>
                      {leadInfo.leadQuality?.label || "Select Quality"}
                    </span>
                  </>
                ) : (
                  <span>Select Quality</span>
                )}
              </div>
              <svg
                className={`w-4 h-4 ml-2 transition-transform ${
                  open ? "rotate-180" : ""
                }`}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path d="M19 9l-7 7-7-7" />
              </svg>
            </div>
            {open && !isEdit && (
              <ul className="absolute z-10 mt-1 w-full bg-white border rounded shadow max-h-60 overflow-y-auto">
                {interestLevel.map((item) => (
                  <li
                    key={item.value}
                    onClick={() => {
                      handleChange("leadQuality", {
                        label: item.label,
                        value: item.value,
                      });
                      setOpen(false);
                    }}
                    className={`flex items-center gap-2 px-4 py-2 cursor-pointer ${
                      leadInfo.leadQuality?.value === item.value
                        ? "bg-green-100 font-medium"
                        : "hover:bg-gray-100"
                    }`}
                  >
                    <img
                      src={item.image}
                      alt={item.label}
                      className="h-5 w-5"
                    />
                    <span>{item.label}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="interestedCategory"
          >
            Interest Categories
          </label>
          <div className="w-3/4">
            <CustomSelect
              value={leadInfo.interestedCategory}
              onChange={handlePropertyType}
              options={GLPagePropertyTypeList.map((type) => ({
                value: type.id,
                label: type.label,
              }))}
              placeholder="Interest property type"
              disabled={isEdit}
            />
          </div>
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="interestedProperty"
          >
            Interest Property
          </label>
          <div className="w-3/4">
            <CustomSelect
              value={leadInfo.interestedProperty}
              onChange={handlePropertyChange}
              onInputChange={handleInputChange}
              options={propertyList}
              placeholder="Interest property"
              disabled={isEdit}
            />
          </div>
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="interestedLocations"
          >
            Interest Location
          </label>
          <div className="w-3/4">
            <CustomSelect
              value={leadInfo.interestedLocations || []}
              onChange={(selectedOptions) =>
                handleChange("interestedLocations", selectedOptions)
              }
              options={optionLocation}
              isMulti
              placeholder="Type Interest Locations"
              disabled={isEdit}
            />
          </div>
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="interestTags"
          >
            Interest Tags
          </label>
          <div className="w-3/4">
            <CustomSelect
              value={leadInfo.interestTags || []}
              onChange={(selectedOptions) =>
                handleChange("interestTags", selectedOptions)
              }
              options={interestedTags}
              isMulti
              placeholder="Type Interest Tags"
              disabled={isEdit}
            />
          </div>
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="status"
          >
            Lead Status
          </label>
          <div className="relative w-3/4" ref={dropdownRef2}>
            <div
              onClick={() => !isEdit && setOpenStatus(!openStatus)}
              className={`flex items-center justify-between w-full px-3 py-2 border rounded ${
                isEdit ? "cursor-default" : "cursor-pointer"
              }`}
            >
              {statusIcons.find((i) => i.label === leadInfo.status?.label) && (
                <div className="flex items-center gap-2">
                  <img
                    src={
                      statusIcons.find(
                        (i) => i.label === leadInfo.status?.label
                      )?.image
                    }
                    alt={leadInfo.status?.label}
                    className="h-5 w-5"
                  />
                  <span>{leadInfo.status?.label || ""}</span>
                </div>
              )}
              <svg
                className={`w-4 h-4 ml-2 transition-transform ${
                  openStatus ? "rotate-180" : ""
                }`}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path d="M19 9l-7 7-7-7" />
              </svg>
            </div>
            {openStatus && (
              <ul className="absolute z-10 mt-1 w-full bg-white border rounded shadow max-h-60 overflow-y-auto">
                {statusIcons.map((item) => (
                  <li
                    key={item.value}
                    onClick={() => {
                      handleChange("status", {
                        label: item.label,
                        value: item.value,
                      });
                      setOpenStatus(false);
                    }}
                    className={`flex items-center gap-2 px-4 py-2 cursor-pointer ${
                      leadInfo.status?.value === item.value
                        ? "bg-green-100 font-medium"
                        : "hover:bg-gray-100"
                    }`}
                  >
                    <img
                      src={item.image}
                      alt={item.label}
                      className="h-5 w-5"
                    />
                    <span>{item.label}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="leadCharacter"
          >
            Character
          </label>
          <div className="relative w-3/4" ref={dropdownRef3}>
            <div
              onClick={() => !isEdit && setOpenInterest(!openInterest)}
              className={`flex items-center justify-between w-full px-3 py-2 border rounded ${
                isEdit ? "cursor-default" : "cursor-pointer"
              }`}
            >
              {leadCharacterEmoji.find(
                (i) => i.label === leadInfo.leadCharacter?.label
              ) && (
                <div className="flex items-center gap-2">
                  <img
                    src={
                      leadCharacterEmoji.find(
                        (i) => i.label === leadInfo.leadCharacter?.label
                      )?.image
                    }
                    alt={leadInfo.leadCharacter?.label}
                    className="h-5 w-5"
                  />
                  <span>{leadInfo.leadCharacter?.label || ""}</span>
                </div>
              )}
              <svg
                className={`w-4 h-4 ml-2 transition-transform ${
                  openInterest ? "rotate-180" : ""
                }`}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path d="M19 9l-7 7-7-7" />
              </svg>
            </div>
            {openInterest && (
              <ul className="absolute z-10 mt-1 w-full bg-white border rounded shadow max-h-60 overflow-y-auto">
                {leadCharacterEmoji.map((item) => (
                  <li
                    key={item.label}
                    onClick={() => {
                      handleChange("leadCharacter", {
                        label: item.label,
                        value: item.value,
                      });
                      setOpenInterest(false);
                    }}
                    className="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  >
                    <img
                      src={item.image}
                      alt={item.label}
                      className="h-5 w-5"
                    />
                    <span>{item.label}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="notes"
          >
            Notes
          </label>
          <textarea
            className={`${
              !isEdit ? "cursor-pointer" : "cursor-default"
            } border rounded w-3/4 py-2 px-3 text-gray-700 input-focus`}
            name="notes"
            type="text"
            required
            rows={5}
            disabled={isEdit}
            value={leadInfo.notes || ""}
            onChange={(e) => handleChange(e.target.name, e.target.value)}
          />
        </div>

        <div className="inline-flex items-center mb-6 justify-center w-full">
          <hr className="w-full h-1 my-8 bg-gray-200 border-0 rounded-sm" />
          <div className="absolute px-4 -translate-x-1/2 bg-white left-1/2">
            <div className="flex items-center gap-3">
              <svg
                className="w-4 h-4 text-gray-700 dark:text-gray-300"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 18 14"
              >
                <path d="M6 0H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3H2a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Zm10 0h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3h-1a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Z" />
              </svg>
              <div className="text-xl">Lead More Info</div>
              <svg
                className="w-4 h-4 text-gray-700 dark:text-gray-300"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 18 14"
              >
                <path d="M6 0H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3H2a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Zm10 0h-4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v1a3 3 0 0 1-3 3h-1a1 1 0 0 0 0 2h1a5.006 5.006 0 0 0 5-5V2a2 2 0 0 0-2-2Z" />
              </svg>
            </div>
          </div>
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="clientLocation"
          >
            Client Location
          </label>
          <input
            className={`${
              !isEdit ? "cursor-pointer" : "cursor-default"
            } border rounded w-3/4 py-2 px-3 text-gray-700 input-focus`}
            name="clientLocation"
            type="text"
            required
            value={leadInfo.clientLocation || ""}
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            disabled={isEdit}
          />
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="clientJobOrBusiness"
          >
            Client Job
          </label>
          <input
            className={`${
              !isEdit ? "cursor-pointer" : "cursor-default"
            } border rounded w-3/4 py-2 px-3 text-gray-700 input-focus`}
            name="clientJobOrBusiness"
            type="text"
            value={leadInfo.clientJobOrBusiness || ""}
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            disabled={isEdit}
          />
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="clientResidentialDetails"
          >
            Residential Details
          </label>
          <input
            className={`${
              !isEdit ? "cursor-pointer" : "cursor-default"
            } border rounded w-3/4 py-2 px-3 text-gray-700 input-focus`}
            name="clientResidentialDetails"
            type="text"
            required
            value={leadInfo.clientResidentialDetails || ""}
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            disabled={isEdit}
          />
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="clientPurpose"
          >
            Client Purpose
          </label>
          <input
            className={`${
              !isEdit ? "cursor-pointer" : "cursor-default"
            } border rounded w-3/4 py-2 px-3 text-gray-700 input-focus`}
            name="clientPurpose"
            type="text"
            required
            value={leadInfo.clientPurpose || ""}
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            disabled={isEdit}
          />
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="clientRequirement"
          >
            Client Requirement
          </label>
          <input
            className={`${
              !isEdit ? "cursor-pointer" : "cursor-default"
            } border rounded w-3/4 py-2 px-3 text-gray-700 input-focus`}
            name="clientRequirement"
            type="text"
            required
            value={leadInfo.clientRequirement || ""}
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            disabled={isEdit}
          />
        </div>

        <div className="mb-8 flex items-center">
          <label
            className="w-2/4 text-[#404040] text-[18px] font-medium"
            htmlFor="paymentType"
          >
            Cash/Loan
          </label>
          <input
            className={`${
              !isEdit ? "cursor-pointer" : "cursor-default"
            } border rounded w-3/4 py-2 px-3 text-gray-700 input-focus`}
            name="paymentType"
            type="text"
            required
            value={leadInfo.paymentType || ""}
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            disabled={isEdit}
          />
        </div>
      </form>
    </div>
  );
};

export default LeadDetail;
